import axios from "axios";
import { apiURI, subscriptionKey } from "../ENVs";

// Attach the APIM subscription key to every request that targets our backend.
// Scoped to apiURI on purpose: blob requests go directly to Azure Storage
// (see ViewImage), and adding an unexpected header there triggers a CORS
// preflight the storage account won't allow.
export function configureAxios() {
  axios.interceptors.request.use((config) => {
    const url = config.url || "";
    if (subscriptionKey && url.startsWith(apiURI)) {
      config.headers["Ocp-Apim-Subscription-Key"] = subscriptionKey;
    }
    return config;
  });
}
